// External Imports
import { createSelector } from 'reselect';

// Local Functions
const getSiteOptionsError = (state) => state.siteOptionsError.error;

const getContentFetchingError = (state) => state.active.error;

const getHasWordPressFetchError = createSelector(
  getSiteOptionsError,
  getContentFetchingError,
  (siteOptionsError, contentFetchingError) =>
    Boolean(siteOptionsError) || Boolean(contentFetchingError),
);

// Module Exports
export { getHasWordPressFetchError };
